module.exports = __webpack_public_path__ + "img/ic_twitter_2.fb3c48a3.svg";